import React from "react";

import loading from "../../static/gifs/loading.gif";

export default function BIHLoading() {
	return <div className='splash-screen' style={{ background: "white" }}></div>;
}
